module.exports = __webpack_public_path__ + "img/hero-dropdown-search-cjdr.5720ffb3.jpg";